
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { ListDataSource } from "@/data/List/ListDataSource";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";
import { Filter } from "@/cms-services/filter";
import draggable from "vuedraggable";
import stringEditor from "@/components/common/inline-editor/string.vue";
import QuizOptions from "./quiz-options.vue";

@Component({
  components: {
    draggable,
    stringEditor,
    QuizOptions,
  },
})
export default class QuizQuestions extends Vue {
  @Prop({ required: true }) quizId!: number;

  loading = false;
  adding = false;
  expandedQuestionId: number | null = null;
  $message: any;

  questionTypes = [
    { value: 1, text: "Один ответ" },
    { value: 2, text: "Несколько" },
    { value: 3, text: "Текст" },
  ];

  questionDataSource: ListDataSource = new ListDataSource({
    className: "quizQuestion",
    config: {
      pageIndex: 1,
      pageSize: 100,
    },
  });

  get questions() {
    return this.questionDataSource.items || [];
  }

  @Watch("quizId", { immediate: true })
  onQuizIdChange() {
    this.loadQuestions();
  }

  async loadQuestions() {
    if (!this.quizId) return;
    
    this.loading = true;
    try {
      this.questionDataSource.config.filter = JSON.stringify([
        new Filter("quizId", this.quizId),
      ]);
      await this.questionDataSource.get();
    } catch (e) {
      console.error("Ошибка загрузки вопросов:", e);
    } finally {
      this.loading = false;
    }
  }

  getQuestionDataSource(question: any) {
    return new ObjectDataSource({
      id: question.id,
      model: question,
      className: "quizQuestion",
      config: {},
    });
  }

  async addQuestion() {
    this.adding = true;
    try {
      const newQuestion = {
        caption: `Вопрос ${this.questions.length + 1}`,
        quizId: this.quizId,
        questionType: 1,
        instanceStateId: 4,
        priority: this.questions.length + 1,
      };
      const created = await this.questionDataSource.add(newQuestion, true);
      this.expandedQuestionId = created.id;
      this.$message?.("Вопрос добавлен");
    } catch (e) {
      console.error("Ошибка создания вопроса:", e);
      this.$message?.("Ошибка создания вопроса");
    } finally {
      this.adding = false;
    }
  }

  async removeQuestion(question: any) {
    if (!confirm("Удалить вопрос?")) return;
    
    try {
      await this.questionDataSource.remove(question.id);
      if (this.expandedQuestionId === question.id) {
        this.expandedQuestionId = null;
      }
      this.$message?.("Вопрос удален");
    } catch (e) {
      console.error("Ошибка удаления вопроса:", e);
    }
  }

  async updateQuestionType(question: any) {
    try {
      await this.getQuestionDataSource(question).updateField({
        fieldName: "questionType",
        fieldValue: question.questionType,
      });
    } catch (e) {
      console.error("Ошибка обновления типа вопроса:", e);
    }
  }

  toggleQuestion(questionId: number) {
    this.expandedQuestionId = this.expandedQuestionId === questionId ? null : questionId;
  }

  async onDragEnd() {
    const updatePromises = this.questions.map((q: any, index: number) => {
      return this.getQuestionDataSource(q).updateField({
        fieldName: "priority",
        fieldValue: index + 1,
      });
    });

    try {
      await Promise.all(updatePromises);
    } catch (e) {
      console.error("Ошибка обновления приоритетов:", e);
    }
  }
}
